import { EntitlementFragment } from '@stigg/api-client-js/src/generated/sdk';
import CachedEntitlement from '../services/cachedEntitlement';

export const buildCacheKeyFromEntitlement = (entitlement: EntitlementFragment): string => {
  const featureId = entitlement.feature?.refId || '';
  return buildCacheKey(featureId, entitlement.resourceId);
};

export const buildCacheKey = (featureId: string, resourceId?: string | null): string => {
  let key = featureId;
  if (resourceId) {
    key = `${key}:${resourceId}`;
  }

  return key;
};

export const filterEntitlementsByResourceId = (
  entitlements: Map<string, CachedEntitlement>,
  resourceId: string | null,
): Array<[entitlementKey: string, entitlement: CachedEntitlement]> => {
  return Array.from(entitlements.entries()).filter((entry) => {
    const [key] = entry;
    const cachedResourceIdParts = (key as string).split(':');
    if (resourceId === null && cachedResourceIdParts.length < 2) {
      return true;
    }
    return cachedResourceIdParts[1] === resourceId;
  });
};
